var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTfbFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 28,
    viewBox: "0 0 46 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 956449176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.3896 8.26562L32.7477 8.26563V10.1869L30.5969 10.1869L30.5969 21.707H28.5404L28.5404 10.1832H26.3896V8.26562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.2723 14.2076L37.9272 14.2076V16.1289L35.2723 16.1289V21.6767L33.2158 21.6767V8.23535L38.6599 8.23535V10.1566L35.2759 10.1566V14.2076H35.2723Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.6806 11.3258V11.8061C45.6806 13.1874 45.2707 14.0736 44.3531 14.513C45.4557 14.956 45.8873 15.9725 45.8873 17.3949V18.4895C45.8873 20.5634 44.821 21.6767 42.7645 21.6767L39.5293 21.6767L39.5293 8.23536L42.634 8.23536C44.763 8.23164 45.6806 9.25184 45.6806 11.3258ZM41.5821 10.1529L41.5821 13.705H42.3873C43.1526 13.705 43.6205 13.3587 43.6205 12.2827V11.5343C43.6205 10.5736 43.3013 10.1529 42.5723 10.1529L41.5821 10.1529ZM41.5821 15.6263L41.5821 19.7555L42.7609 19.7555C43.4536 19.7555 43.8272 19.4278 43.8272 18.43V17.2571C43.8272 16.0098 43.4355 15.6263 42.4998 15.6263H41.5821Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.8021 14.9294C16.8038 17.2403 14.9807 19.1136 12.7314 19.1154L12.7367 26.1337C18.7626 26.1284 23.6438 21.1102 23.6386 14.9241L16.8021 14.9294Z",
    fill: "#278484"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.724 10.7509C14.975 10.7491 16.7998 12.6207 16.8015 14.9298L21.8185 14.9262C21.8167 12.3492 20.7973 10.0169 19.15 8.32933C17.5026 6.64173 15.229 5.5988 12.7188 5.60059L12.724 10.7509Z",
    fill: "#2C405A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.732 19.1155C10.4809 19.1173 8.65614 17.2457 8.6544 14.9366C8.65266 13.7812 9.10843 12.7347 9.84601 11.9775L3.72096 5.70032C1.4195 8.06654 -0.00347279 11.3346 6.3653e-06 14.9438C0.00522509 22.1603 5.70929 28.0071 12.7389 28L12.732 19.1155Z",
    fill: "#66CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M9.84321 11.9776C10.5808 11.2204 11.5984 10.7507 12.7239 10.7507L12.7153 0C8.69857 0.00357166 5.06286 1.67689 2.43262 4.38242L9.84321 11.9776Z",
    fill: "#278484"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTfbFrame);
export default __webpack_public_path__ + "static/media/tfbFrame.c47cd2530c65e1e55c3b8ac27482a316.svg";
export { ForwardRef as ReactComponent };